
const tryResolveTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (err) {
    return null;
  }
};

const timezoneService = {
  tryResolveTimezone,
};
export default timezoneService;